import { PropType, ExtractPropTypes } from "vue";
import { UiTypes } from "@various/constants";

export type UiStepsInputModelValue = {
    "end"?: number;
    "start"?: number;
    "end-steps"?: number;
    "start-steps"?: number;
};

export const UiStepsInputPropsOption = {
    placeholder: { type: Object as PropType<{ start?: string; end?: string }> } /**提示文本 */,
    widthNumber: { type: Number, default: 76 },
    modelValue: { type: Object as PropType<UiStepsInputModelValue>, required: true },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    spacing: { type: Number, default: 14 },
    width: { type: Number, default: 408 },
    size: { type: String as PropType<UiTypes.size>, default: "default" },
    name: { type: String },
} as const;

export type UiStepsInputProps = ExtractPropTypes<typeof UiStepsInputPropsOption>;

export const UiStepsInputEmits = {
    change: (_ev: Event) => true,
    input: (_ev: InputEvent | Event) => true,
    focus: (_ev: FocusEvent | Event) => true,
    blur: (_ev: FocusEvent | Event) => true,
};
